<nav class="public-header navbar navbar-expand-lg navbar-light fixed-top">
    <img src="../../../../assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}" height="30">
  </nav> <!-- /.navbar -->
  
  <div class="page">
    <div class="page-content">
      <div>

        <div class="row main-row" *ngIf="showVideo">
          <div class="col-12 p-5 align-items-center justify-content-center">
            <video id="idVideo" preload="auto" controls autoplay width="100%" height="auto">
              <source src="assets/video/Archedi-SD3.mp4" type="video/mp4">
              <source src="assets/video/Archedi-SD3.webm" type="video/webm">
              <source src="assets/video/Archedi-SD3.ogv" type="video/ogg">
            </video>
          </div>
        </div>
  
      </div> <!-- /.container -->
    </div> <!-- /.page-content -->
  </div> <!-- /.page -->